import Axios from 'axios';

import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import { DEFAULT_VALUE_ACHIEVEMENTS_POLLING_INTERVAL_MILLISECONDS } from 'enum/achievementsSettings';
import ApiService from 'services/ApiService/ApiService';
import UserStore from 'stores/UserStore';
import allUserGroups from 'enum/userGroups';


const ACHIEVEMENTS_BASE_URL = ConfigurationService.get(ConfigurationKeys.ACHIEVEMENTS_BASE_URL);

const v1 = '/rest/v1.0';
const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);
const PROFILE_URL = `${BASE_URL}${v1}/profile`;

const ACHIEVEMENTS_SERVICE = 'achievementsService';
const ACHIEVEMENTS_PROFILE = 'achievementsProfile';
const ACHIEVEMENTS_PROFILE_ERROR = 'achievementsProfileErrors';
const ACHIEVEMENTS_DISMISS = 'achievementsDismiss';
const ACHIEVEMENTS_ERROR = 'achievementsErrors';

const DEFAULT_PAGE = 1;
const DEFAULT_LIMIT = 0;

const normalizeAchievements = (achievements) =>
  achievements.map((achievement) => {
    const { 'additional_data': aditionalData, '_id': id, ...rest } = achievement;

    return { aditionalData, id, ...rest };
  });

const filterDisabledAchievements = (achievements) => {
  if (UserStore.hasCF(allUserGroups.ACHIEVEMENTS_SECTION_PHASE2)) {
    return achievements;
  }

  return achievements.filter((a) => a.tags?.phase !== 2);
};

export const getAchievements = (userId, page, limit) => async(dispatch) => {
  let achievementsURL = undefined;
  try {
    achievementsURL = new URL(`${ACHIEVEMENTS_BASE_URL}/achievements/users/${userId}`);
  } catch (err) {
    achievementsURL = new URL(`${window.location.origin}/achievements/users/${userId}`);
  }

  try {
    const TIME_OUT = ConfigurationService.get(ConfigurationKeys.ACHIEVEMENTS_POLLING_INTERVAL_MILLISECONDS) ||
    DEFAULT_VALUE_ACHIEVEMENTS_POLLING_INTERVAL_MILLISECONDS;

    achievementsURL.searchParams.set('page', page || DEFAULT_PAGE);
    achievementsURL.searchParams.set('limit', limit || DEFAULT_LIMIT);

    const res = await Axios.get(achievementsURL, { timeout: TIME_OUT });

    const payload = filterDisabledAchievements(normalizeAchievements(res.data.results));

    dispatch({ type: ACHIEVEMENTS_SERVICE, payload });
  } catch (error) {
    const payload = { active: true };

    if (error.response) {
      payload.code = error.status;
      payload.message = error.statusText;
    }

    dispatch({ type: ACHIEVEMENTS_ERROR, payload });
  }
};

export const getAchievementsProfile = (username, page, limit) => async(dispatch) => {
  let achievementsURL = undefined;
  try {
    achievementsURL = new URL(`${ACHIEVEMENTS_BASE_URL}/achievements/users/`);
  } catch (err) {
    achievementsURL = new URL(`${window.location.origin}/achievements/users/`);
  }

  try {
    const infoRes = await ApiService.sendRequestWithRetries(
      ApiService.get,
      `${PROFILE_URL}/${username}/info`,
    );

    const { userId } = infoRes.data;

    achievementsURL.pathname += String(userId);
    achievementsURL.searchParams.set('page', page || DEFAULT_PAGE);
    achievementsURL.searchParams.set('limit', limit || DEFAULT_LIMIT);

    const achievementsRes = await ApiService.sendRequestWithRetries(
      ApiService.get,
      achievementsURL,
      { withCredentials: false }
    );

    const payload = filterDisabledAchievements(normalizeAchievements(achievementsRes.data.results));

    dispatch({ type: ACHIEVEMENTS_PROFILE, payload });
  } catch (error) {
    const payload = { active: true };

    if (error.response) {
      payload.code = error.status;
      payload.message = error.statusText;
    }

    dispatch({ type: ACHIEVEMENTS_PROFILE_ERROR, payload });
  }
};

export const dismissNotification = (id) => (dispatch) => {
  dispatch({ type: ACHIEVEMENTS_DISMISS, payload: { id } });
};
